import { GET_PROFILE_REQUESTED, GET_UPDATEPROFILE_REQUESTED } from "resources/actionTypes";

export function getProfile(data) {
  return {
    type: GET_PROFILE_REQUESTED,
    payload:data ? data : {}
  };
}

export function patchUpdateProfile(userUpdateProfile) {
  const data ={
    userUpdateProfile:userUpdateProfile,
  }
  return {
    type: GET_UPDATEPROFILE_REQUESTED,
    payload: data,
  };
}
